<script setup lang="ts">
  import type { OrderDetailsTimeline } from '~/types/ecommerce/generated.codegen';

  const props = defineProps<{
    orderSteps: (OrderDetailsTimeline | null)[] | undefined;
    preSale?: boolean | null;
    deliveryEstimate?: string | null;
    schedulePickupText?: string | null;
  }>();

  const { width } = useWindowSize();
  const isMobile = computed(() => width.value <= 768);

  const steps = computed(
    () =>
      props.orderSteps?.map(step => ({
        key: step?.status as string,
        text: step?.step as string,
        subtitle: step?.subtitle as string,
        failed: step?.error,
        informative: step?.informative,
        current: step?.error
          ? step.current
          : step?.completed
            ? false
            : step?.current,
        finished: step?.completed,
      })) || [],
  );
</script>

<template>
  <div class="product-steps">
    <div
      v-if="schedulePickupText || deliveryEstimate"
      class="order-delivery-estimate">
      <PreSale
        v-if="preSale"
        variant="tag"
        class="order-delivery-estimate__presale-tag" />
      <h2 class="order-delivery-estimate__text">
        {{ schedulePickupText || deliveryEstimate }}
      </h2>
    </div>

    <SolSteps
      id="package"
      class="steps"
      :steps="steps"
      :direction="isMobile ? 'column' : 'row'" />
  </div>
</template>

<style lang="scss">
  .order-delivery-estimate {
    @apply mb-2xs flex w-full flex-wrap items-center gap-nano;

    &__presale-tag {
      @apply shrink-0;
    }

    &__text {
      @apply fonts-heading-h3 min-w-0 flex-1 text-neutral-low-dark md:site:text-xs;
    }
  }

  .product-steps {
    @apply mb-xs gap-2xs rounded-none border-none px-2xs pb-micro pt-2xs;
    @apply xsm:site:px-micro md:site:flex md:site:h-auto md:site:flex-col md:site:justify-center;
    min-width: 0;
    width: 100%;

    > .steps {
      @apply w-full min-w-0 max-w-full;
      height: 278px;

      @media (min-width: 769px) {
        height: auto;
      }

      &.-column > .step:last-child {
        flex-grow: 0;
      }

      > .step > .link > .label {
        max-width: 100%;
        overflow-wrap: anywhere;
        padding-inline: 2px;
        white-space: normal;
      }
    }
  }
</style>
